module.exports = __webpack_public_path__ + "img/logo-hermes.a31f6a1.png";